<div class="fpay" *ngIf="methods.length">

    <button type="button" class="fpay__strip" (click)="toggle($event)"
            [attr.aria-expanded]="open" aria-haspopup="dialog"
            [attr.title]="'payments-see-all' | t:'See everything we accept'">

        <app-icon class="fpay__lock" size="20" name="fi-payment-security-48"></app-icon>
        <span class="fpay__label">{{ 'we-accept' | t:'We accept' }}</span>

        <span class="fpay__coins">
            <app-payment-marks *ngIf="hasCard" set="cards" [only]="['visa', 'mastercard', 'amex']" [height]="18"></app-payment-marks>
        </span>
    </button>

    <!-- Plain overlay rather than a modal library: this component renders on every page,
         including server-side, and a self-contained panel has nothing to go wrong there. -->
    <div class="fpay__backdrop" *ngIf="open" (click)="close()"></div>

    <div class="fpay__panel" *ngIf="open" role="dialog" [attr.aria-label]="'payment-methods-accepted' | t:'Accepted payment methods'">
        <div class="fpay__panel-head">
            <h5>{{ 'what-we-accept' | t:'What we accept' }}</h5>
            <button type="button" class="fpay__close" (click)="close()" [attr.aria-label]="'close' | t:'Close'">&times;</button>
        </div>

        <div class="fpay__panel-body">
            <div class="fpay__method" *ngFor="let m of methods">
                <div class="fpay__method-name">{{ m.Name }}</div>
                <app-payment-marks *ngIf="m.Code === 'card'" class="fpay__method-marks" set="cards" [height]="22"></app-payment-marks>
                <div class="fpay__method-note">{{ m.Note }}</div>
            </div>

            <p class="fpay__fine">
                {{ hasCard ? ('payments-prices-currency-card' | t:'Prices are shown in your currency, and a card is charged in it through Stripe.') : ('payments-prices-currency' | t:'Prices are shown in your currency.') }}
            </p>
        </div>
    </div>
</div>
